import { Box } from '@mui/material';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTap';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import HomePage from './pages/HomePage';
import Pricing from './pages/Pricing';
import Apply from './pages/Apply';
import TeknikDestek from './pages/TeknikDestek';
import FeatureDetailPage from './pages/FeatureDetailPage';
import PricingPageNew from './pages/PricingPageNew';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import HomePageKurumsal from './pages/HomePageKurumsal';
import FinansMuhasebePage  from './pages/FinansMuhasebePage';
import ProjectAndActivityPage  from './pages/ProjectAndActivityPage';
import { IletişimPage } from './pages/IletişimPage';
import { RaporlamaPage } from './pages/RaporlamaPage';
import BagisYonetimiPage from './pages/BagisYonetimiPage';
import UyeYonetimiPage from './pages/UyeYonetimiPage';
import WebWidgetSystemPage from './pages/WebWidgetSystemPage';
import EBYSPage from './components/EBYSPage';
import NotFound from './pages/NotFound';
import VideoKonferansPage from './pages/VideoKonferansPage';
import TopluSMSPage from './pages/TopluSMSPage';
import PushNotification from './pages/PushNotification';
import { TenantProvider, useTenant } from './context/TenantContext';

const TenantHomePage = () => {
  const tenant = useTenant();

  
  if (tenant.tenantId === 'derneksistem') {
    return <HomePageKurumsal />;
  }
  return <HomePage tenant={tenant} />;
};

function App() {
  return (
    <Router>
      <TenantProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <ScrollToTop />
          <Navbar />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={<TenantHomePage />} />
              <Route path="/kurumsal" element={<HomePageKurumsal />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/iletisim" element={<ContactPage />} />
              <Route path="/ucretlendirme" element={<Pricing />} />
              <Route path="/fiyatlandirma" element={<PricingPageNew />} />
              <Route path="/basvuru" element={<Apply />} />
              <Route path="/teknik-destek" element={<TeknikDestek />} />
              <Route path="/ozellikler/:slug" element={<FeatureDetailPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogDetailPage />} />
              <Route path="/ozellikler/finans-muhasebe" element={<FinansMuhasebePage />} />
              <Route path="/ozellikler/uye-yonetimi" element={<UyeYonetimiPage />} />
              <Route path='/ozellikler/web' element={<WebWidgetSystemPage />} />
              <Route path="/ozellikler/projeler" element={<ProjectAndActivityPage />} />
              <Route path="/ozellikler/iletisim" element={<IletişimPage />} />
              <Route path="/ozellikler/raporlama" element={<RaporlamaPage />} />
              <Route path="/ozellikler/bagis-yonetimi" element={<BagisYonetimiPage />} />
              <Route path="/ozellikler/video-konferans" element={<VideoKonferansPage />} />
              <Route path="/ozellikler/ebys" element={<EBYSPage />} />
              <Route path="/ozellikler/toplu-sms" element={<TopluSMSPage/>} />
              <Route path="/ozellikler/toplu-bildirim" element={<PushNotification />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </TenantProvider>
    </Router>
  );
}

export default App;